import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "../../../assets/css/swiper.css";
import { Pagination, Autoplay } from "swiper";
import brystsmerter from "../../../assets/karousel/brystsmerter.png";
import børneundersøgelse from "../../../assets/karousel/BU1.png";
import dm from "../../../assets/karousel/DM nyopdaget.png";
import dm2 from "../../../assets/karousel/DM2 sygeplejerske.png";
import ekscision from "../../../assets/karousel/Ekscision af process.png";
import gastroskopi from "../../../assets/karousel/Gastroskopi.png";
import knætraume from "../../../assets/karousel/Knætraume.png";
import rygsmerter from "../../../assets/karousel/Rygsmerter.png";
import uvi from "../../../assets/karousel/UVI_karusel.png";

export default function SygdomCarousel() {
  return (
    <Swiper
      pagination={{ clickable: true }}
      loop={true}
      autoplay={{
        delay: 5500,
        disableOnInteraction: false,
      }}
      slidesPerView={1}
      slidesPerGroup={1}
      modules={[Pagination, Autoplay]}
      className="sygdomKarousel w-full h-100"
    >
      <SwiperSlide key={0}>
        <img
          src={brystsmerter}
          alt="Brystsmerter eksempel"
          className="rounded-lg w-100"
        />
      </SwiperSlide>

      <SwiperSlide key={1}>
        <img
          src={børneundersøgelse}
          alt="børneundersøgelse eksempel"
          className="rounded-lg w-100"
        />
      </SwiperSlide>

      <SwiperSlide key={2}>
        <img src={dm} alt="DM eksempel" className="rounded-lg w-100" />
      </SwiperSlide>

      <SwiperSlide key={3}>
        <img src={dm2} alt="DM2 eksempel" className="rounded-lg w-100" />
      </SwiperSlide>

      <SwiperSlide key={4}>
        <img
          src={ekscision}
          alt="Ekscision eksempel"
          className="rounded-lg w-100"
        />
      </SwiperSlide>

      <SwiperSlide key={5}>
        <img
          src={gastroskopi}
          alt="Gastroskopi eksempel"
          className="rounded-lg w-100"
        />
      </SwiperSlide>

      <SwiperSlide key={6}>
        <img
          src={knætraume}
          alt="Knætraume eksempel"
          className="rounded-lg w-100"
        />
      </SwiperSlide>

      <SwiperSlide key={7}>
        <img
          src={rygsmerter}
          alt="Rygsmerter eksempel"
          className="rounded-lg w-100"
        />
      </SwiperSlide>

      <SwiperSlide key={8}>
        <img src={uvi} alt="Uvi eksempel" className="rounded-lg w-100" />
      </SwiperSlide>
    </Swiper>
  );
}
